import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import { AccountTypeField } from './AccountTypeFieldExtension';
import {  AccountUsageType } from './types';

const AccountTypeFieldSchema: CustomFieldExtensionSchema = {
  returnValue: {
    type: 'object',
    properties: {
      account_usage: { 
        type: 'string', 
        enum: Object.values(AccountUsageType),
        title: 'Account Usage'
      },
      environment: { 
        type: 'array', 
        items: { type: 'string' },
        minItems: 1,
        title: 'Environments'
      },
      admin_email: { 
        type: 'string', 
        format: 'email',
        title: 'Admin Email'
      },
      brand: { 
        type: 'string',
        title: 'Brand'
      },
      custom_fields: {
        type: 'object',
        properties: {
          budget: {
            type: 'number',
            minimum: 0,
            title: 'Account Budget',
            description: 'Specifies a whole dollar amount which is used to set a budget and budget alerts for the account. If not set, there is no budget enforced.'
          }
        }
      },
      application_name: { 
        type: 'string',
        title: 'Application Name'
      },
      team_members: { 
        type: 'array', 
        items: { 
          type: 'string', 
          format: 'email' 
        },
        title: 'Team Members'
      },
      application_category: { 
        type: 'string',
        title: 'Application Category'
      }
    },
    required: ['account_usage', 'environment', 'admin_email', 'brand'],
    dependencies: {
      account_usage: {
        oneOf: [
          {
            properties: {
              account_usage: { enum: [AccountUsageType.FuseApp, AccountUsageType.NonFuseApp] }
            },
            required: ['application_name', 'application_category']
          },
          {
            properties: {
              account_usage: { enum: [AccountUsageType.Developer] }
            }
          },
          {
            properties: {
              account_usage: { enum: [AccountUsageType.DevOps] }
            }
          }
        ]
      }
    }
  }
};


export const AccountTypeFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AccountTypeField',
    component: AccountTypeField,
    schema: AccountTypeFieldSchema,
  }),
);

